import { initializeApp } from 'firebase/app';
import { connectFirestoreEmulator, getFirestore } from 'firebase/firestore';
import {
  getAuth,
  signInWithCustomToken as authSignInWithCustomToken,
  onAuthStateChanged,
} from 'firebase/auth';
import getEnvironmentVariables from './getEnvironmentVariables';

const environmentVariables = getEnvironmentVariables();

// if (environmentVariables.NODE_ENV === "development") {
// if (true) {
//   setLogLevel("debug");
// }

const firebaseApp = initializeApp({
  apiKey: environmentVariables.TODESKTOP_CLI_FIREBASE_API_KEY,
  authDomain: environmentVariables.TODESKTOP_CLI_FIREBASE_AUTH_DOMAIN,
  databaseURL: environmentVariables.TODESKTOP_CLI_FIREBASE_DATABASE_URL,
  projectId: environmentVariables.TODESKTOP_CLI_FIREBASE_PROJECT_ID,
  storageBucket: environmentVariables.TODESKTOP_CLI_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:
    environmentVariables.TODESKTOP_CLI_FIREBASE_MESSAGING_SENDER_ID,
  appId: environmentVariables.TODESKTOP_CLI_FIREBASE_ID,
});

const auth = getAuth(firebaseApp);
const db = getFirestore(firebaseApp);

const [host, port] =
  environmentVariables.TODESKTOP_CLI_FIRESTORE_HOST?.split(':') || [];
if (host && port) {
  connectFirestoreEmulator(db, host, Number.parseInt(port, 10));
}

interface FirebaseUser {
  displayName: string | null;
  email: string | null;
  getIdToken(forceRefresh?: boolean): Promise<string>;
  uid: string;
}

export const currentUser = (): FirebaseUser | null => {
  return auth.currentUser as FirebaseUser | null;
};
export const signInWithCustomToken = async (token: string) => {
  return authSignInWithCustomToken(auth, token);
};

/**
 * onUserAuth is only triggered on sign-in. This
 * happens once signInWithCustomToken is successful.
 *
 * It technically also triggers on sign-out but there's
 * no concept of signing out of firebase with the CLI app.
 * (See logout command which just deletes a local file)
 */
export const onUserAuth = (
  handler: (user: Partial<FirebaseUser>) => void,
): (() => void) =>
  onAuthStateChanged(auth, (user) => {
    handler(((user as FirebaseUser | null) ?? {}) as Partial<FirebaseUser>);
  });

export default db;
